import { render, staticRenderFns } from "./SuccessGenerateReport.vue?vue&type=template&id=24081a6a&"
import script from "./SuccessGenerateReport.vue?vue&type=script&lang=js&"
export * from "./SuccessGenerateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports